"use client";

import * as React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button"; // Adjust this path to your Button.tsx

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

const CollapsibleContentPanel = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.CollapsibleContent
    ref={ref}
    className={cn(
      "overflow-hidden", // Prevents content from leaking over rounded corners
      className,
    )}
    {...props}
  />
));
CollapsibleContentPanel.displayName = "CollapsibleContentPanel";

// Then export it
export { Collapsible, CollapsibleTrigger, CollapsibleContent, CollapsibleContentPanel };
